import { render } from "./TreatmentsTabContent.vue?vue&type=template&id=3c3cde33&scoped=true&ts=true"
import script from "./TreatmentsTabContent.vue?vue&type=script&lang=ts"
export * from "./TreatmentsTabContent.vue?vue&type=script&lang=ts"

import "./TreatmentsTabContent.vue?vue&type=style&index=0&id=3c3cde33&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c3cde33"]])

export default __exports__